/* ==================================================
   PRIM DRESS — GLOBAL THEME CONTROLLER
   ================================================== */

(function () {
  'use strict';

  const STORAGE_KEY = 'primdress_theme';
  const ROOT = document.documentElement;

  function getSavedTheme() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark'
        ? 'dark'
        : 'light';
    } catch (error) {
      return 'light';
    }
  }

  function applyTheme(theme) {
    const selectedTheme = theme === 'dark' ? 'dark' : 'light';

    ROOT.setAttribute('data-prim-theme', selectedTheme);

    try {
      localStorage.setItem(STORAGE_KEY, selectedTheme);
    } catch (error) {}

    document.querySelectorAll('[data-prim-theme-toggle]').forEach(function (button) {
      button.setAttribute(
        'aria-label',
        selectedTheme === 'dark'
          ? 'Switch to light mode'
          : 'Switch to dark mode'
      );

      button.setAttribute(
        'aria-pressed',
        selectedTheme === 'dark' ? 'true' : 'false'
      );
    });

    document.dispatchEvent(
      new CustomEvent('primdress:theme-change', {
        detail: { theme: selectedTheme }
      })
    );
  }

  /* Apply saved theme immediately */
  applyTheme(getSavedTheme());

  /* One global click listener */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-prim-theme-toggle]');

    if (!button) return;

    const currentTheme = ROOT.getAttribute('data-prim-theme');
    applyTheme(currentTheme === 'dark' ? 'light' : 'dark');
  });

  /* Keep controls updated if sections load dynamically */
  const observer = new MutationObserver(function () {
    const currentTheme = ROOT.getAttribute('data-prim-theme') || 'light';

    document.querySelectorAll('[data-prim-theme-toggle]').forEach(function (button) {
      button.setAttribute(
        'aria-label',
        currentTheme === 'dark'
          ? 'Switch to light mode'
          : 'Switch to dark mode'
      );

      button.setAttribute(
        'aria-pressed',
        currentTheme === 'dark' ? 'true' : 'false'
      );
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();